import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { IconBug } from '@tabler/icons-react';
import { useState } from 'react';
import { cn } from '../../lib/utils';
import { BugReportModal } from './BugReportModal';
import { captureScreen } from './captureScreen';
/**
 * "Report a bug" — a topbar utility that sits with search, Assist, the theme
 * toggle and notifications. It used to be a floating 48px circle pinned to the
 * bottom-right corner, which overlapped page content (drawer footers, the
 * Assist rail's composer) and read as a support widget bolted onto the app
 * rather than part of its chrome.
 */ export function BugReportButton({ className }) {
    const [isOpen, setIsOpen] = useState(false);
    const [isCapturing, setIsCapturing] = useState(false);
    const [screenshot, setScreenshot] = useState(null);
    // Capture BEFORE opening, so the frame is the page the reporter is looking
    // at and not our dialog on top of it.
    const open = async ()=>{
        setIsCapturing(true);
        setScreenshot(await captureScreen());
        setIsCapturing(false);
        setIsOpen(true);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("button", {
                onClick: open,
                disabled: isCapturing,
                "data-testid": Testids.bugReport.openButton,
                // Matches the theme toggle beside it, so the utility cluster reads as
                // one row of controls.
                className: cn('flex size-8 items-center justify-center rounded-md text-muted-foreground transition-colors hover:bg-muted hover:text-foreground', className),
                title: "Report a bug",
                "aria-label": "Report a bug",
                type: "button",
                children: /*#__PURE__*/ _jsx(IconBug, {
                    size: 16
                })
            }),
            /*#__PURE__*/ _jsx(BugReportModal, {
                isOpen: isOpen,
                onOpenChange: setIsOpen,
                screenshot: screenshot,
                onRemoveScreenshot: ()=>setScreenshot(null)
            })
        ]
    });
}
